import Hero from "@/components/home/Hero";
import LogoWall from "@/components/home/LogoWall";
import Stats from "@/components/home/Stats";
import BillboardHero from "@/components/home/BillboardHero";
import CaseStudiesFeatured from "@/components/home/CaseStudiesFeatured";
import WhyPrulo from "@/components/home/WhyPrulo";
import ServicesGrid from "@/components/home/ServicesGrid";
import HowWeRun from "@/components/home/HowWeRun";
import HowWeBill from "@/components/home/HowWeBill";
import ForCreatorsBand from "@/components/home/ForCreatorsBand";
import CTABlock from "@/components/shared/CTABlock";

export default function Home() {
  return (
    <div data-testid="page-home">
      <Hero />
      <LogoWall />
      <Stats />
      <BillboardHero />
      <CaseStudiesFeatured />
      <WhyPrulo />
      <ServicesGrid />
      <ForCreatorsBand />
      <HowWeRun />
      <HowWeBill />
      <CTABlock />
    </div>
  );
}
